import React from 'react';

import { IconProps } from './types';

export const CheckmarkSecondaryIcon = React.forwardRef<
  SVGSVGElement,
  IconProps
>(({ color = 'currentColor', ...props }, forwardedRef) => {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <circle cx="12" cy="12" fill="white" r="9.75" />
      <path
        d="M20.2776 6.85153C20.1682 6.67575 19.9338 6.62106 19.7619 6.73044C16.6604 8.64841 13.6721 12.4179 11.8947 15.3867C11.7619 15.6054 11.5276 15.7422 11.2697 15.75C11.2619 15.75 11.258 15.75 11.2502 15.75C11.0002 15.75 10.7697 15.625 10.6291 15.4218C9.84396 14.2656 8.21115 12.5351 7.1213 11.8984C6.76193 11.6875 6.64083 11.2265 6.85177 10.8711C7.0588 10.5117 7.51974 10.3906 7.87912 10.6015C8.85177 11.1718 10.0705 12.3437 11.0002 13.4453C11.0979 13.5586 11.2697 13.5508 11.3518 13.4258C13.3361 10.4101 16.1447 7.14841 19.1213 5.35935H19.1174C19.5901 5.07419 20.0588 4.832 20.5158 4.63669C20.8947 4.47263 21.0705 4.03513 20.9104 3.65231C20.7463 3.2695 20.301 3.09372 19.926 3.25778C19.2815 3.53513 18.6213 3.8906 17.9572 4.31638C15.9611 2.75778 13.3557 1.94528 10.5471 2.35544C6.27365 2.98044 2.85958 6.46872 2.32833 10.7578C1.53537 17.1133 6.91427 22.4804 13.2736 21.6679C17.6838 21.1054 21.2151 17.4961 21.6916 13.0742C21.9377 10.7812 21.383 8.62497 20.2776 6.85153Z"
        fill="#A3C855"
      />
    </svg>
  );
});
